

(function() {
    'use strict';
    window.addEventListener('load', function() {
      
        sessionStorage.removeItem("submit_type");
      	
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
              sessionStorage.setItem("submit_type", "submit");
              doValidate(form, event);                
            }, false);
          
          	form.querySelector("#form-submit").addEventListener("click", function(event){
              if(sessionStorage.getItem("submit_type") === "submit"){
              	return false;                          
              }
              sessionStorage.setItem("submit_type", "click");              
		      doValidate(form, event);   
            }, false);
        });




// Form Validation

   var formInteriorismo = document.getElementsByClassName('contacto-interiorismo');

    var formCalligaris = document.getElementsByClassName('contacto-calligaris');

       var formShowroom = document.getElementsByClassName('contacto-showroom');

         var formCatalogos = document.getElementsByClassName('catalogo-calligaris');

              for (var i = 0; i < formCatalogos.length; i++) {
         formCatalogos[i].addEventListener('submit', function(event) {
            //alert("Submit");
            event.preventDefault(); // Evita el envío inicial del formulario
            // Ejecuta tu función aquí
            sendLeadPrototype(this, "interes-formCatalogos");
           setTimeout(() => {
  this.submit()
}, "1000");        
          });
        }


        for (var i = 0; i < formInteriorismo.length; i++) {
         formInteriorismo[i].addEventListener('submit', function(event) {
            //alert("Submit");
            event.preventDefault(); // Evita el envío inicial del formulario
            // Ejecuta tu función aquí
            sendLeadPrototype(this, "interes-formInteriorismo");
           setTimeout(() => {
  this.submit()
}, "1000");        
          });
        }

        for (var i = 0; i < formCalligaris.length; i++) {
         formCalligaris[i].addEventListener('submit', function(event) {
            //alert("Submit");
            event.preventDefault(); // Evita el envío inicial del formulario
            // Ejecuta tu función aquí
            sendLeadPrototype(this, "interes-formCalligaris");
           setTimeout(() => {
  this.submit()
}, "1000");        
          });
        }

      
        for (var i = 0; i < formShowroom.length; i++) {
         formShowroom[i].addEventListener('submit', function(event) {
            //alert("Submit");
            event.preventDefault(); // Evita el envío inicial del formulario
            // Ejecuta tu función aquí
            sendLeadPrototype(this, "interes-formShowroom");
           setTimeout(() => {
  this.submit()
}, "1000");        
          });
        }





      
    }, false);
})();

function doValidate(form, event){
    
	console.log("submitted form");

    var formId = form.id;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      console.log('form validation Failed');	                  
      $("input.form-control").each(function(){
        if($(this).is(":invalid")){
          $(this).parent().addClass("invalid");
        } else {
          $(this).parent().removeClass("invalid");
        }
      });
    } else {
      console.log('form validation Succesful');
      $("#form-submit", form).text("Enviando...");
      $("#form-submit", form).addClass('disabled');                    

      sendLeadPrototype(form, formId);
    }
    form.classList.add('was-validated');
}

function sendLeadPrototype(ref, id) {
    var agencia = window.agenciaFormData;

    // URL de API
    var url_api = "https://adpdev.com/adp/mx/seguimiento/index.php";

    // Nodo meta del body request
    var meta = { "action": "create-lead-para-usuarios-cartas", "version": "5.0" };

    // Construye el dataset
    var dataset = buldDataset();

    // Grabar valores en dataset del cliente
    dataset = buldDatasetSettings(dataset, agencia);

    /**
    * C Ó D I G O   C U S T O M
    * ------------------------------------------
    */

    // Información capturada por el lead
    // Nota: Se deja el selector original pero se añade un fallback vacío para evitar errores
    dataset.nombre      = $('#contact-firstname', ref).val() || "";
    dataset.apellidos   = $('#contact-lastname', ref).val() || "";
    dataset.email       = $('#contact-email', ref).val() || "";
    dataset.telefono    = $('#contact-phone', ref).val() || "";
    dataset.comentarios = $('#contact-comments', ref).val() || "";
    dataset.cp          = "";
  
    // Información de producto
    dataset.productname = $('#contact-comments', ref).attr("data-producttitle");
    dataset.producturl = $('#contact-comments', ref).attr("data-producturl");

    // URL del formulario de conversión
    dataset.info.conversion_form =  window.location.href;

    var precomentario = '';

    // MEJORA 1: Detección por clase para que el Switch no se pierda
    if (ref.classList.contains('contacto-calligaris')) id = "interes-formCalligaris";
    else if (ref.classList.contains('contacto-interiorismo')) id = "interes-formInteriorismo";
    else if (ref.classList.contains('contacto-showroom')) id = "interes-formShowroom";
    else if (ref.classList.contains('catalogo-calligaris')) id = "interes-formCatalogos";

    // Switch de id´s de formulario
    switch (id) {

      case "interes-formCalligaris":
        dataset.nombre = ref.querySelector("input[name='contact[name]']").value;
        dataset.apellidos = ref.querySelector("input[name='contact[last_name]']").value;
        dataset.email = ref.querySelector("input[name='contact[email]']").value;
        dataset.telefono = ref.querySelector("input[name='contact[phone]']").value;
        dataset.comentarios  = ref.querySelector("textarea[name='contact[message]']").value;
        dataset.asunto = "Formulario Contacto Calligaris";
        dataset.typ = "https://calligarismexico.com/pages/contacto";
        precomentario = "Interesado en Contacto Calligaris";
        dataset.id_formatoTipo = 4;
        localStorage.setItem("catalogLead", "true");
        console.log(dataset)
        break;

        case "interes-catalogo":
            dataset.asunto = "Formulario Catálogo Calligaris";
          dataset.typ = "https://calligaris-test.myshopify.com/pages/catalogos";
          precomentario = "Interesado en Catálogo Calligaris";
            dataset.id_formatoTipo = 4;
          localStorage.setItem("catalogLead", "true");
            break;
        
        case "interes-producto":
          dataset.asunto = "Interesado en Producto";
          if(dataset.productname && dataset.producturl){
            precomentario = '<br><b>Producto:</b> ' + dataset.productname;
            precomentario += '<br><b>Url:</b> ' + '<a href="https://'+window.location.hostname + dataset.producturl+'" target="_blank">'+dataset.producturl+'</a>';
          }
          
          dataset.id_formatoTipo = 4;
          break;
        
        case "contacto-general":
          dataset.asunto = "Interesado en Contacto General";
          dataset.id_formatoTipo = 4;
          break;

        case "interes-formInteriorismo":
            dataset.nombre = ref.querySelector("input[name='contact[Nombre]']").value;
            dataset.email = ref.querySelector("input[name='contact[email]']").value;
            dataset.telefono = ref.querySelector("input[name='contact[Teléfono]']").value;
            dataset.comentarios  = ref.querySelector("textarea[name='contact[Mensaje]']").value;
            dataset.asunto = "Formulario Interiorismo Calligaris";
            dataset.typ = "https://calligarismexico.com/pages/interiorismo";
            precomentario = "Interesado en contactar con un especialista en interiorismo";
            dataset.id_formatoTipo = 4;
            localStorage.setItem("catalogLead", "true");
            break;

        case "interes-formShowroom":
            dataset.nombre = ref.querySelector("input[name='contact[name]']").value;
            dataset.apellidos = ref.querySelector("input[name='contact[last_name]']").value;
            dataset.email = ref.querySelector("input[name='contact[email]']").value;
            dataset.telefono = ref.querySelector("input[name='contact[phone]']").value;
        
            dataset.sucursal = ref.querySelector("select[name='contact[sucursal]']").value;
            dataset.fecha = ref.querySelector("input[name='contact[cita]']").value;
            dataset.hora = ref.querySelector("select[name='contact[hour]']").value;
        
            dataset.asunto = "Formulario Cita Showroom Calligaris";
            dataset.typ = "https://calligarismexico.com/pages/contacto-showrooms";
            
            precomentario = `Reserva de cita en showroom ${dataset.sucursal} el ${dataset.fecha} a las ${dataset.hora}:00 hrs`;
            
            dataset.id_formatoTipo = 4;
            localStorage.setItem("catalogLead", "true");
            break;

        case "interes-formCatalogos":
            dataset.nombre = ref.querySelector("input[name='contact[name]']").value;
            dataset.apellidos = ref.querySelector("input[name='contact[last_name]']").value;
            dataset.email = ref.querySelector("input[name='contact[email]']").value;
            dataset.telefono = ref.querySelector("input[name='contact[phone]']").value;
            dataset.asunto = "Formulario Catálogos Calligaris";
            dataset.typ = "https://calligarismexico.com/pages/catalogos";
            precomentario = "Interesado en los catálogos";
            dataset.id_formatoTipo = 4;
            localStorage.setItem("catalogLead", "true");
            break;
        
        default:
            dataset.asunto = "Interesado en Contacto General";
            dataset.id_formatoTipo = 4;
            break;
    }

    dataset.comentarios = (dataset.comentarios) ? dataset.comentarios += " " + precomentario : precomentario;

    // Suscribir a Newsletter
    if($("#newsletter_optin").is(':checked')){
        dataset.id_newsletterEstado = 1;
    }else{
        dataset.id_newsletterEstado = 0;
    }

    dataset.template_testing = true;

    //--------------------------------------------

    var allreq = { "meta": meta, "dataset": dataset };
    var stringjson = JSON.stringify(allreq);
    console.log("BUZON REQUEST DEBUG:");
    console.log(allreq);

    var error = false;
    jQuery.ajax({
        url: url_api,
        type: 'POST',
        data: stringjson,
        cache: false,
        beforeSend: function() {
            // Operaciones para hacer mientas se completa el envío
        },
        success: function(data, status, xhr) {
            console.log("BUZON RESPONSE DEBUG:");
            console.log(data);
            if (data.meta.status != "ok") {
                // Error al intentar enviar
                $("#boton-enviar", ref).val("Ocurrio un problema :(");
            } else {
                // Envío exitoso
                $("#boton-enviar", ref).val("¡Excelente!");
                var form_tipo = data.dataset.id_formatoTipo;
                var id_suscriber = "";
                if(typeof data.dataset.idx_suscriber !== "undefined" && data.dataset.idx_suscriber != null && data.dataset.idx_suscriber != ""){
                    id_suscriber = data.dataset.idx_suscriber;
                }
              
              if(dataset.typ){
                window.location.href = dataset.typ;
              } else {
                redirectTyp(form_tipo,id_suscriber);
              }
            }
        }
    });
}

function redirectTyp(form_tipo,id_suscriber){
    var tipo;

    switch(form_tipo){
        case 1:
            tipo = 'general';
            break;

        default:
            tipo = 'general';
            break;
    }
    var url = "/pages/gracias?t=" + tipo;
    if(typeof id_suscriber !== "undefined" && id_suscriber != null && id_suscriber != "NULL" && id_suscriber != ""){
        url = url + "&adpmetrics_u=" + id_suscriber;
    }
    window.location.href = url;
}


function buldDatasetSettings(dataset, agencia){

    var agencia_seguimiento_id = $('#contact-agencia').val();
    var agencia_cartacx_id     = $('#contact-agencia').find(":selected").attr('data-cartasid');
    var agencia_name           = $('#contact-agencia').find(":selected").text();

    // URL del Home de la landing
    dataset.dominio = window.location.hostname;

    // ¿Asunto fijo? (Si el asunto es fijo, no funcionarán los replys de mail, email piping)
    dataset.asunto_fixed = false;

    // Template para transeccionales de registro de nuevo lead
    dataset.email_notify_enduser = null;
    dataset.email_notify_backoffice = null;

    // From para envío de transaccionales
    dataset.from_mail_buzon = "seguimiento@crmautomotriz.com";
    dataset.from_address_agencia_buzon = "Calligaris Store";

    // Nombre de la agencia para mostrar en transaccionales
    dataset.agencia_nombre = "Calligaris Store";

    if (document.location.search == "?formtest=true") {
        // ID Agencia de DB Prueba de manejo Adpunto
        dataset.id_agencia = 1;

        // ID Cliente de DB Cartas Adpunto
        dataset.id_agencia_cartas = 15;
    } else {
        // ID Agencia de DB Prueba de manejo Adpunto
        dataset.id_agencia = 140;

        // ID Cliente de DB Cartas Adpunto
        dataset.id_agencia_cartas = 154;
    }


    // ID del tipo de status inicial, para el lead, de DB Prueba Manejo
    dataset.id_statusNuevo = 1;

    return dataset;
}

function setDisclaimerText(){
    var submit_text = $("#form-submit").text();
    var disclaimer  = "";
    disclaimer += '<div id="privacy-disclaimer">';
    disclaimer += 'Al dar clic en "'+ submit_text + '", aceptas nuestro ';
    disclaimer += '<a target="_blank" href="/aviso-de-privacidad">aviso de privacidad</a>.';
    disclaimer += '</div>';

    if($("#form-submit").length){
        $("#form-disclaimer").html(disclaimer);
    }
}


/*Abrir chat*/
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
	  	purechatApi.on('chatbox:ready', function () {
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			const getInitChat = urlParams.get('initchat');
			if(typeof getInitChat !== 'undefined' && getInitChat == "chat"){
				purechatApi.set('chatbox.expanded', true); // Expanded the chat box (false collapses it)
			}

			const getNombre = urlParams.get('name');
			if(typeof getNombre !== 'undefined'){
				purechatApi.set('visitor.name', getNombre); // Sets the visitor name to "Joe Doe"
			}

			const getEmail = urlParams.get('email');
			if(typeof getEmail !== 'undefined'){
				purechatApi.set('visitor.email', getEmail); // Sets the visitor name to "Joe Doe"
			}

			const getPhone = urlParams.get('phone');
			if(typeof getPhone !== 'undefined'){
				purechatApi.set('visitor.phoneNumber', getPhone); // Sets the visitor name to "Joe Doe"
			}

			const get_utm_source = urlParams.get('utm_source');
			const get_utm_medium = urlParams.get('utm_medium');
			if(typeof get_utm_source !== 'undefined' && get_utm_source =="adpmx" &&  typeof get_utm_medium !== 'undefined' && get_utm_medium =="email"){
				purechatApi.set('visitor.question', 'Estoy interesado en las promociones que llegaron a mi email');
			}
		});
	}, "2000");
});
	



